import {makeAutoObservable} from 'mobx';
import {v4 as uuidv4} from "uuid";
import CreateObjectTableau from "../components/ObjetsElementaires/CreateObject/CreateObjectTableau";
import React from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CreateObjectText from "../components/ObjetsElementaires/CreateObject/CreateObjectText";
import axios from "axios";
import CreateObjectUrl from "../components/ObjetsElementaires/CreateObject/CreateObjectUrl";
import {addObjetElem, getObjetElemById, loadNiveaux, updateObjetElem} from "../utils/requests";
import CreateObjectCalendar from "../components/ObjetsElementaires/CreateObject/CreateObjectCalendar";

// https://mobx.js.org/defining-data-stores.html

export default class NiveauxIndicateurStore {
    idWidgetIndicateurOuvert = "";
    levels = [{
        id: uuidv4(),
        type: 'form',
        active: true,
        widgets: []
    }];

    objetTextValue = null;
    /* *** ObjetElem Calendrier *** */
    objetCalendrierSourceType = null;
    objetCalendrierTitle = null;
    objetCalendrierIDSource = '0';
    objetCalendrierIDSourceObj = '0';
    objetCalendrierIDInfosContext = '0';
    objetCalendrierColSource = null;
    objetCalendrierSeuils = null;
    objetCalInfoContTitle = null;
    objetCalInfoColTableau = null;
    objetCalInfoUpdate = [];
    objetCalendriercolInfoTitle = '';

    objetTableauValue = {
        colonne: [
            {
                col_nom_affiche: '',
                col_nom_sasp: '',
                obj_elem_id: ''
            }
        ],
        tab_nom: '',
        tab_id_requete_sasp: '0',
        tab_nb_result: '10',
        obj_source_type : ''
    };

    // obj elem => URL
    objetUrlNom = null;
    objetUrlAdresse = null;

    elementaryWidgetsAvailable = [
        {
            idWidget: uuidv4(),
            config: [],
            typeWidget: 'ObjetTexte',
            nomWidget: 'Texte'
        },
        {
            idWidget: uuidv4(),
            config: [],
            typeWidget: 'ObjetTableau',
            nomWidget: 'Tableau'
        },
        {
            idWidget: uuidv4(),
            config: [],
            typeWidget: 'ObjetUrl',
            nomWidget: 'URL'
        },
        {
            idWidget: uuidv4(),
            config: [],
            typeWidget: 'ObjetCalendrier',
            nomWidget: 'Calendrier'
        }
    ]


    constructor() {
        // makeAutoObservable
        // https://mobx.js.org/observable-state.html
        makeAutoObservable(this);
    }

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    // update var levels when move a objElem in level of WidgetIndicator
    // Call on onLayoutChange function in CreateIndicateurNiveaux.js l:32
    updateLayoutLevel(layout) {
        let that = this.levels.find(el => el.active).widgets;
        let newLayout = [];
        layout.map((i) => {
            let objUpdated = that?.find(obj => obj.obj_elem_id === i.i);
            if (typeof objUpdated !== 'undefined') {
                newLayout.push({
                    obj_elem_id: objUpdated.obj_elem_id,
                    obj_elem_pos_x: i.x,
                    obj_elem_pos_y: i.y,
                    obj_elem_pos_w: i.w,
                    obj_elem_pos_h: i.h,
                    obj_elem_type: objUpdated.obj_elem_type,
                    obj_id_niveau: objUpdated.obj_id_niveau,
                    config: objUpdated.config
                });
            }
        });
        if (newLayout.length !== 0) {
            this.levels.find(el => el.active).widgets = newLayout;
        }
    }

    // Default empty config, otherwise overrides
    addLevel(_ent, idWidget =  this.idWidgetIndicateurOuvert) {
        let levelId = uuidv4();
        this.levels.push({
            id: levelId,
            active: false,
            type: 'level',
            widgets: [],
        });

        axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/addNiveau',
            {
                niv_id: levelId,
                idWidget,
                niv_num: this.levels.length,
            },
            { headers: {"Authorization" : `Bearer ${this.getCookie(_ent+"_apiToken")}`} }
        ).then(function (response) {

        })
            .catch(function (error) {

            });

        this.updateCurrentLevel(levelId);
    }

    /*
    Renvoie l'index de l'élément qui est actif
     */
    get currentIndex() {
        return this.levels.findIndex((el) => el.active)
    }

    get currentLevel() {
        return this.levels.find(el => el.active)
    }

    isActive(id) {
        let level = this.levels.find(el => el.id === id);
        return level.active === true;
    }

    removeCurrentLevel(_ent) {
        let _index = this.currentIndex;
        let _newIndex = _index - 1;
        let _idLevel = this.levels[_index].id;
        console.log("this.levels",this.levels);
        console.log("_index",_index);

        let newActiveLevel = this.levels.find(el => el.id === this.levels[_newIndex].id);
        this.updateCurrentLevel(newActiveLevel.id);
        this.levels.splice(_index, 1);
        axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/deleteNiveau', {niv_id: _idLevel},
            { headers: {"Authorization" : `Bearer ${this.getCookie(_ent+"_apiToken")}`} });
    }

    objetElmControl(type) {
        if (type === 'ObjetTableau'){
            if (this.objetTableauValue.tab_id_requete_sasp === '0'){
                Swal.showValidationMessage(
                    `Veuillez sélectionner une source de données !`
                )
            }
            else if (this.objetTableauValue.colonne.length === 0){
                Swal.showValidationMessage(
                    `Veuillez ajouter des colonnes`
                )
            }
            else if (this.objetTableauValue.colonne.length !== 0){
                this.objetTableauValue.colonne.map((col) => {
                    if(col.col_nom_sasp === ''){
                        Swal.showValidationMessage(
                            `Les colonnes ne peuvent pas être vides !`
                        )
                    }
                });
            }
        }
        else if (type === 'ObjetTexte'){
            if (this.objetTextValue === null || this.objetTextValue === '') {
                Swal.showValidationMessage(
                    `Veuillez renseigner un texte !`
                )
            }
        }
        else if (type === 'ObjetUrl'){
            if (this.objetUrlAdresse === null || this.objetUrlAdresse === ''){
                Swal.showValidationMessage(
                    `Veuillez renseigner une URL valide !`
                )
            }
        }
        else if (type === 'ObjetCalendrier'){
            if (this.objetCalendrierTitle === null || this.objetCalendrierTitle === ''){
                Swal.showValidationMessage(
                    `Veuillez renseigner un titre au calendrier !`
                )
            }
            if (this.objetCalendrierIDSource === null || this.objetCalendrierIDSource === ''){
                Swal.showValidationMessage(
                    `Veuillez renseigner une source de données !`
                )
            }
            if (this.objetCalendrierColSource === null || this.objetCalendrierColSource === ''){
                Swal.showValidationMessage(
                    `Veuillez renseigner une colonne de la source de données !`
                )
            }
            if (this.objetCalInfoContTitle === null || this.objetCalInfoContTitle === ''){
                Swal.showValidationMessage(
                    `Veuillez renseigner un titre au infos contextuelles !`
                )
            }
            if (this.objetCalInfoColTableau === null || this.objetCalInfoColTableau === ''){
                Swal.showValidationMessage(
                    `Veuillez ajouter au moins un champ d'infos contextuelles !`
                )
            }
        }

    }

    /*
    Gestion des modales pour la création des widgets
     */
    async handleDropWidget(widget, idObjElem) {
        const ModalObject = withReactContent(Swal);
        this.resetObjetElem();

        switch (widget.typeWidget) {
            case 'ObjetTableau':
                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Ajouter un objet tableau <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    allowOutsideClick: false,
                    html: <CreateObjectTableau data={this.objetTableauValue}/>,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(widget.typeWidget)
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.objetTableauValue.obj_elem_id = idObjElem;
                        let _table = this.objetTableauValue;

                            // Ajout des IDS aux colonnes
                            _table.colonnes = _table.colonne.map((col, i) => {
                                col.obj_elem_id = idObjElem;
                                col.col_colonnes_id = i + 1;
                                return col;
                            });

                            return Promise.resolve({
                                isConfirmed: true,
                                config: this.objetTableauValue,
                                w: 3,
                                h: 2
                            })

                    } else {
                        return Promise.resolve({
                            isConfirmed: false
                        })
                    }
                });
            case 'ObjetTexte':
                return ModalObject.fire({
                    // https://github.com/sweetalert2/sweetalert2/issues/1440
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Ajouter un objet texte <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectText/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(widget.typeWidget)
                }).then((result) => {
                    if (result.isConfirmed) {
                        return Promise.resolve({
                            isConfirmed: true,
                            config: {
                                obj_elem_id: idObjElem,
                                text_contenu: this.objetTextValue,
                            },
                            w: 3,
                            h: 1
                        })
                    } else {
                        return Promise.resolve({
                            isConfirmed: false
                        })
                    }
                })
            case 'ObjetUrl':
                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Ajouter un objet URL <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectUrl/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(widget.typeWidget)
                }).then((result) => {
                    if (result.isConfirmed) {
                        return Promise.resolve({
                            isConfirmed: true,
                            config: {
                                obj_elem_id: idObjElem,
                                url_nom: this.objetUrlNom,
                                url_url_adress: this.objetUrlAdresse,
                            },
                            w: 4,
                            h: 6
                        })
                    } else {
                        return Promise.resolve({
                            isConfirmed: false
                        })
                    }
                })
            case 'ObjetImage':
                return Swal.fire({
                    title: 'Choisir une image',
                    input: 'file',
                    inputAttributes: {
                        'accept': 'image/*',
                        'aria-label': 'Upload your profile picture'
                    }
                })
            case "ObjetCalendrier":
                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Ajouter un objet calendrier <div class="float-right cursor-pointer mb-4"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectCalendar/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(widget.typeWidget)
                }).then((result) => {
                    if (result.isConfirmed) {
                        let id_infos_context = '';
                        if (this.objetCalendrierIDInfosContext === '0'){
                            id_infos_context = uuidv4();
                        } else {
                            id_infos_context = this.objetCalendrierIDInfosContext;
                        }

                        if (this.objetCalendriercolInfoTitle !== '' && this.objetCalendriercolInfoTitle !== null) {
                            this.objetCalInfoColTableau.push({colInfo_title: this.objetCalendriercolInfoTitle, colInfo_uuid: uuidv4()})
                        }

                        let promise = {
                            isConfirmed: true,
                            config: {
                                obj_elem_id: idObjElem,
                                cal_nom: this.objetCalendrierTitle,
                                cal_id_requete_sasp: this.objetCalendrierIDSource,
                                cal_id_list_objectif: this.objetCalendrierIDSourceObj,
                                cal_col_requete_sasp: this.objetCalendrierColSource,
                                obj_source_type: this.objetCalendrierSourceType,
                                id_infos_context,
                                listeSeuils: this.objetCalendrierSeuils,
                                infoContext:{
                                    id_infos_context,
                                    infos_context_titre: this.objetCalInfoContTitle,
                                    infos_context_json_structure: this.objetCalInfoColTableau
                                }
                            },
                            w: 5,
                            h: 6
                        };

                        this.objetCalendrierSourceType = null;
                        this.objetCalendriercolInfoTitle = null;
                        this.objetCalendrierTitle = null;
                        this.objetCalendrierIDSource = '0';
                        this.objetCalendrierIDSourceObj = null;
                        this.objetCalendrierColSource = null;
                        this.objetCalendrierSeuils = null;
                        this.objetCalInfoContTitle = null;
                        this.objetCalInfoColTableau = null;
                        this.objetCalendrierIDInfosContext = '0';

                        return Promise.resolve(promise)
                    } else {
                        return Promise.resolve({
                            isConfirmed: false
                        })
                    }
                })
            default:
                return Promise.resolve({
                    isConfirmed: false
                })
        }
    }

    async handleUpdateObjetElem(idObjet, type, ent) {
        const ModalObject = withReactContent(Swal);
        const data = await getObjetElemById(idObjet, ent);
        switch (type) {
            case 'ObjetTableau':
                // FAIRE LA REQUETE SAPS
                this.objetTableauValue = data.config;

                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Modifier un tableau <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    // width: 800,
                    allowOutsideClick: false,
                    html: <CreateObjectTableau idObjet={idObjet} data={data.config}/>,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(type)
                }).then(async (result) => {

                    if (result.isConfirmed) {
                        let _table = this.objetTableauValue;
                        // Ajout des IDS aux colonnes
                        _table.colonnes = _table.colonne.map((col, i) => {
                            col.obj_elem_id = idObjet;
                            col.col_colonnes_id = i + 1;
                            return col;
                        });

                        await this.updateWidget({
                            idObjElem: idObjet,
                            typeObjet: 'ObjetTableau',
                            config: {...this.objetTableauValue}
                        },ent)
                    }
                })
            case 'ObjetTexte':
                return ModalObject.fire({
                    // https://github.com/sweetalert2/sweetalert2/issues/1440
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Modifier un objet texte <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectText idObjet={idObjet} data={data}/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(type)
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.updateWidget({
                            idObjElem: idObjet,
                            typeObjet: 'ObjetTexte',
                            config: {
                                obj_elem_id: idObjet,
                                text_contenu: this.objetTextValue
                            }
                        },ent)
                    }
                })
            case 'ObjetUrl':
                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Modifier un objet texte <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectUrl idObjet={idObjet} data={data}/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(type)
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await this.updateWidget({
                            idObjElem: idObjet,
                            typeObjet: 'ObjetUrl',
                            config: {
                                obj_elem_id: idObjet,
                                url_nom: this.objetUrlNom,
                                url_url_adress: this.objetUrlAdresse,
                            }
                        },ent)
                    }

                })
            case 'ObjetImage':
                return Swal.fire({
                    title: 'Choisir une image',
                    input: 'file',
                    inputAttributes: {
                        'accept': 'image/*',
                        'aria-label': 'Upload your profile picture'
                    }
                }).then((result) => {
                    let levels = this.levels;
                    this.cleanup();
                    this.levels = levels;
                })
            case "ObjetCalendrier":
                return ModalObject.fire({
                    position: 'top-end',
                    customClass: {
                        container: 'swal2__Container-class',
                        popup: 'swal2__Popup-class',
                        htmlContainer: 'swal2__Content-class',
                        actions: 'swal2__Actions-class',
                        denyButton: 'swal2__DenyButton-class',
                        confirmButton: 'swal2__ConfirmButton-class',
                        closeButton : 'swal2__CloseButton-class'
                    },
                    showClass: {
                        popup: `
                          animate__animated
                          animate__fadeInRight
                          animate__faster
                        `,
                    },
                    hideClass: {
                        popup: `
                          animate__animated
                          animate__fadeOutRight
                          animate__faster
                        `,
                    },
                    width: 620,
                    showCloseButton: true,
                    closeButtonHtml: 'Modifier un calendrier <div class="float-right cursor-pointer"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M10.2363 7.16016L14.8809 12.0004L10.2363 16.8406" stroke="#70787B" stroke-width="2"></path><line x1="14.6973" y1="12.3281" x2="2.43556" y2="12.3281" stroke="#70787B" stroke-width="2"></line><line x1="19.0469" y1="5.39844" x2="19.0469" y2="18.6044" stroke="#70787B" stroke-width="2"></line></svg></div>',

                    html: <CreateObjectCalendar idObjet={idObjet} data={data}/>,
                    allowOutsideClick: false,
                    showDenyButton: true,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Valider',
                    // confirmButtonColor: '#1976d2',
                    denyButtonText: 'Annuler',
                    preConfirm: () => this.objetElmControl(type)
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let id_infos_context = '';
                        if (this.objetCalendrierIDInfosContext === '0'){
                            id_infos_context = uuidv4();
                        } else {
                            id_infos_context = this.objetCalendrierIDInfosContext;
                        }

                        if (this.objetCalendriercolInfoTitle !== '' && this.objetCalendriercolInfoTitle !== null) {
                            this.objetCalInfoColTableau.push({colInfo_title: this.objetCalendriercolInfoTitle, colInfo_uuid: uuidv4()})
                        }

                        await this.updateWidget({
                            idObjElem: idObjet,
                            typeObjet: 'ObjetCalendrier',
                            config: {
                                obj_elem_id: idObjet,
                                cal_nom: this.objetCalendrierTitle,
                                obj_source_type: this.objetCalendrierSourceType,
                                cal_id_requete_sasp: this.objetCalendrierIDSource,
                                cal_id_list_objectif: this.objetCalendrierIDSourceObj,
                                cal_col_requete_sasp: this.objetCalendrierColSource,
                                id_infos_context,
                                listeSeuils: this.objetCalendrierSeuils,
                                infoContext:{
                                    id_infos_context,
                                    infos_context_titre: this.objetCalInfoContTitle,
                                    infos_context_json_structure: this.objetCalInfoColTableau
                                }
                            }
                        },ent)
                        this.objetCalendrierSourceType = null;
                        this.objetCalendriercolInfoTitle = null;
                        this.objetCalendrierTitle = null;
                        this.objetCalendrierIDSource = '0';
                        this.objetCalendrierIDSourceObj = '0';
                        this.objetCalendrierColSource = null;
                        this.objetCalendrierSeuils = null;
                        this.objetCalInfoContTitle = null;
                        this.objetCalInfoColTableau = null;
                        this.objetCalendrierIDInfosContext = '0';
                    } else {
                        this.objetCalendrierSourceType = null;
                        this.objetCalendriercolInfoTitle = null;
                        this.objetCalendrierTitle = null;
                        this.objetCalendrierIDSource = '0';
                        this.objetCalendrierIDSourceObj = '0';
                        this.objetCalendrierColSource = null;
                        this.objetCalendrierSeuils = null;
                        this.objetCalInfoContTitle = null;
                        this.objetCalInfoColTableau = null;
                        this.objetCalendrierIDInfosContext = '0';
                        return Promise.resolve({
                            isConfirmed: false
                        })
                    }
                })
            default:
                return Promise.resolve({
                    isConfirmed: false
                })
        }
    }

    generateLayout(layoutId) {
        const layout = this.levels.find((l) => l.id === layoutId);

        let widgetsLayout = [];
        /*
        REFACTORED
        [0] : undefined
         */
        layout.widgets.forEach(widget => {
            if (typeof widget !== "undefined") {
                widgetsLayout.push({
                    i: widget.obj_elem_id,
                    x: widget.obj_elem_pos_x,
                    y: widget.obj_elem_pos_y,
                    w: widget.obj_elem_pos_w,
                    h: widget.obj_elem_pos_h,
                    static: false,
                    typeWidget: widget.obj_elem_type,
                    idWidget: widget.obj_elem_id
                });
            }
        })
        return widgetsLayout
    }

    async updateWidget({idObjElem = '', typeObjet = '', config = {}},ent) {

        let res = await updateObjetElem({
            idObjElem: idObjElem,
            typeObjet: typeObjet,
            config: config
        }, ent)

        let currentKey = this.currentIndex;
        let level = this.levels[currentKey];
        let widgetIndex = level.widgets.findIndex((w) => w.id = idObjElem);

        if (res.status !== 200) {
            alert('ERREUR API');
            return;
        }

        let _levels = this.levels.map((l, i) => {
            if (l.id === this.currentLevel.id) {
                let _l = l;
                _l.widgets.map((w) => {
                    if (w.obj_elem_id === idObjElem) {
                        w.config = config;
                    }
                    return w;
                })
                return _l;
            }
            return l;
        })

        this.levels = _levels;
    }

    getWidgetById(idWidget) {
        let _widget

        this.levels.forEach((level) => {
            if (level.type === 'form') {
                return
            }
            level.widgets.forEach(widget => {
                if (widget?.obj_elem_id === idWidget) {
                    _widget = widget
                }
            })
        })

        return _widget;
    }

    async addWidget(objet = {},ent) {
        let _levels = this.levels.map(el => {
            if (el.active === true) {
                el.widgets.push(objet)
            }
            return el;
        });
        this.levels = _levels;

        let res = await addObjetElem({
            idNiveau: objet.obj_id_niveau,
            idObjElem: objet.obj_elem_id,
            x: objet.obj_elem_pos_x,
            y: objet.obj_elem_pos_y,
            w: objet.obj_elem_pos_w,
            h: objet.obj_elem_pos_h,
            typeObjet: objet.obj_elem_type,
            config: objet.config
        },ent)

    }

    /*
    Met à jour l'élément courant actif grâce à son ID
     */
    updateCurrentLevel(id) {
        let _levels = this.levels;

        for (let level of _levels) {
            level.active = false;
        }

        let level = _levels.find(el => el.id === id);
        level.active = true;

        this.levels = _levels;
    }

    setCurrentWidgetId(value) {
        this.idWidgetIndicateurOuvert = value;
    }


    reload() {
        let levels = this.levels;
        this.cleanup();
        this.levels = levels;
    }

    cleanup() {
        this.levels = [{
            id: uuidv4(),
            type: 'form',
            active: true
        }];
        this.idWidgetIndicateurOuvert = ""
    }

    async getNbNiveaux(idWidget, _ent) {
        const response = await axios.get(process.env.REACT_APP_API_URL + '/api/indicateur/haveNiveau/' + idWidget,
            { headers: {"Authorization" : `Bearer ${this.getCookie(_ent+"_apiToken")}`} });
        return response.data
    }

    async loadNiveaux(idWidget, mode, ent) {
        this.levels = await loadNiveaux(idWidget, mode, ent);
    }

    removeObjetElem(IdObjetElem, _ent) {
        let _index = this.currentIndex;
        let _idLevel = this.levels[_index].id;

        this.levels.map(el => {
            if (el.id === _idLevel) {
                var ii;
                for (ii = 0; ii < el.widgets.length; ii++) {
                    if (el.widgets[ii].obj_elem_id === IdObjetElem) {
                        this.levels[_index].widgets.splice(ii, 1);
                    }
                }
            }
        });

        axios.post(process.env.REACT_APP_API_URL + '/api/indicateur/niveau/deleteObjElem', {obj_elem_id: IdObjetElem},
            { headers: {"Authorization" : `Bearer ${this.getCookie(_ent+"_apiToken")}`} });
    }


    resetObjetElem() {
        this.objetTextValue = null;
        this.objetTableauValue = {
            colonne: [],
            tab_nom: '',
            tab_id_requete_sasp: '0',
            tab_nb_result: '10',
            obj_source_type : ''
        };
        this.objetUrlNom = null;
        this.objetUrlAdresse = null;
    }
}
